<div class="content">
  @let vUser = user();

  @if (vUser) {
    @if (showAvatar()) {
      <at-avatar [class]="size()" [name]="vUser | name"></at-avatar>
    }
    @if (hasName()) {
      <span class="primary-field">{{ vUser.name }}</span>
    } @else if (replaceNameWith() === "email") {
      <span class="primary-field">{{ vUser.email }}</span>
    } @else if (replaceNameWith() === "unknown") {
      <span class="primary-field">Unknown user</span>
    }

    <div class="badges">
      @if (isMe() && !hideMeBadge()) {
        <div class="user-me">Me</div>
      }
      @if (showOwnerBadge()) {
        <div class="user-owner">Organizer</div>
      }
      <ng-content select=".badge"></ng-content>
    </div>
    @if (shouldShowEmail()) {
      <span class="secondary-field">{{ vUser.email }}</span>
    }
  }
</div>
